export const SwooshRightBlue = () => {
    return (
        <svg
            width="376"
            height="157"
            viewBox="0 0 376 157"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.3"
                d="M500.546 57.4563C432.155 15.7357 336.619 -6.28839 203.17 29.4693C142.508 45.7236 55.7982 101.863 8.79747 148.743"
                stroke="url(#swoosh-right-blue-gradient)"
                strokeWidth="23"
            />
            <defs>
                <linearGradient
                    id="swoosh-right-blue-gradient"
                    x1="370.326"
                    y1="45.7614"
                    x2="-480.219"
                    y2="270.64"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#79E2F2" />
                    <stop
                        offset="0.411458"
                        stopColor="#79E2F2"
                        stopOpacity="0"
                    />
                    <stop
                        offset="0.526042"
                        stopColor="#79E2F2"
                        stopOpacity="0"
                    />
                    <stop offset="1" stopColor="#EAE6FF" />
                    <stop offset="1" stopColor="#79E2F2" />
                </linearGradient>
            </defs>
        </svg>
    );
};
